import { moveGlide } from './_image-gallery-slider-configuration.js';

let ImageGallerySlider = document.querySelectorAll('.text-and-image-gallery');
let clientX = 0;
let clientY = 0;
let animationDelay = 300;

if(ImageGallerySlider.length > 0) {
    ImageGallerySlider.forEach((slider, index) => {
        let arrowPrev = slider.querySelector('.glide__arrows button.prev');
        let arrowNext = slider.querySelector('.glide__arrows button.next');
        let nextField = slider.querySelector('.cursor-next-field');
        let prevField = slider.querySelectorAll('.cursor-prev-field');
        const glideID = slider.querySelector('.glide').getAttribute('id');

        if(window.innerWidth > 900) {
            window.addEventListener("mousemove", e => {
                clientX = e.clientX;
                clientY = e.clientY;
                arrowNext.style.left = clientX+'px';
                arrowNext.style.top = clientY+'px';
                arrowPrev.style.left = clientX+'px';
                arrowPrev.style.top = clientY+'px';
            });
        }
    
        nextField.addEventListener("mouseover", e => {
            arrowNext.classList.add('active');
            setTimeout(() => {  
                arrowNext.style.width = arrowNext.children[0].clientWidth+28+'px';
            }, animationDelay);
        });
        
        nextField.addEventListener("mouseleave", e => {
            arrowNext.classList.remove('active');
            arrowNext.style.width = 32+'px';
        });
        
        nextField.addEventListener("click", e => {
            moveGlide('>', glideID);
        });
        
        prevField.forEach(function(slide) {
          slide.addEventListener("mouseover", e => {
            if(e.target.classList.contains('button-style') && arrowPrev.classList.contains('active')) {
              arrowPrev.classList.remove('active');
              arrowPrev.style.width = 32+'px'
            }
            else if(!arrowPrev.classList.contains('active')) {
              arrowPrev.classList.add('active');
              setTimeout(() => {  
                arrowPrev.style.width = arrowPrev.children[0].clientWidth+28+'px';
              }, animationDelay);
            }
          });
        });

        prevField.forEach(function(slide) {
          slide.addEventListener("mouseleave", e => {
            if(e.relatedTarget.classList.contains('cursor-prev-field')) {
              return;
            }
            arrowPrev.classList.remove('active');
            arrowPrev.style.width = 32+'px';
          });
        });

        prevField.forEach(function(slide) {
          slide.addEventListener("click", e => {
            if(!e.target.classList.contains('button-style')) {
              moveGlide('<', glideID);
            }
          });
        });

        arrowPrev.addEventListener("click", e => {
            moveGlide('<', glideID);
        });

        arrowNext.addEventListener("click", e => {
            moveGlide('>', glideID);
        });

    });
}